/* eslint-disable */
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import Img from "../components/Img";
import { style } from "./LocationDetail";

function policyRow(label, val) {
  return (
    <tr key={label}>
      <td style={{padding:"6px 24px 6px 0", color:"#666", fontSize:13}}>{label}</td>
      <td style={{padding:"6px 0"}}>{val === true ? "✓ Allowed" : val === false ? "✗ Not allowed" : val ?? "—"}</td>
    </tr>
  );
}

export default function VenueResourceDetail() {
  const { locationSlug, resourceSlug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/inventory-v2/locations/${locationSlug}/venues/${resourceSlug}`)
      .then(r => setData(r.data))
      .catch(e => setError(e?.response?.data?.detail || e.message));
  }, [locationSlug, resourceSlug]);

  if (error) return <div style={{...style.wrap, padding:60}}>Error: {error}</div>;
  if (!data) return <div style={{...style.wrap, padding:60}}>Loading…</div>;

  const { resource: r, location: loc, organization: org } = data;
  const v = r.venue || {};
  const pricing = v.pricing || {};
  const permitted = v.permitted_uses || [];
  const prohibited = v.prohibited_uses || [];

  return (
    <div style={style.wrap} data-testid="v2-venue-detail">
      <div style={style.banner}>Métier · Inventory V2 Preview · Admin only</div>
      <main style={style.main}>
        <div style={{fontSize:12, color:"#666"}}>
          Métier › <Link to={`/locations/${loc.slug}`} style={{color:"#666"}}>{loc.name}</Link> › <strong>{r.name}</strong>
        </div>
        <span style={{...style.eyebrow, marginTop:12, display:"inline-block"}}>Venue · {r.venue_type?.replace(/_/g, " ")}</span>
        <h1 style={style.h1}>{r.name}</h1>
        <div style={style.meta}>
          {loc.name} · {v.seated_capacity ? `Seated ${v.seated_capacity}` : null}
          {v.standing_capacity ? ` · Standing ${v.standing_capacity}` : null}
          {r.square_feet ? ` · ${r.square_feet} sq ft` : null}
        </div>

        {r.images?.length > 0 && (
          <div style={style.gallery}>
            {r.images.slice(0, 3).map((g, i) => <Img key={i} src={g} alt={`${r.name} ${i + 1}`} style={style.galleryImg} />)}
          </div>
        )}

        {r.description ? <p style={{maxWidth:720, marginTop:24, lineHeight:1.7}}>{r.description}</p> : null}

        <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:24, marginTop:32}}>
          <div>
            <h2 style={{...style.h2, marginTop:0, fontSize:24}}>Pricing</h2>
            <table style={{borderCollapse:"collapse"}}>
              <tbody>
                {policyRow("Model", pricing.model)}
                {pricing.base_rate_cents ? policyRow("Base rate", `$${(pricing.base_rate_cents/100).toFixed(0)}`) : null}
                {policyRow("Minimum hours", v.minimum_hours)}
                {pricing.minimum_spend_cents ? policyRow("Minimum spend", `$${(pricing.minimum_spend_cents/100).toFixed(0)}`) : null}
                {v.cleaning_fee_cents ? policyRow("Cleaning fee", `$${(v.cleaning_fee_cents/100).toFixed(0)}`) : null}
                {v.security_deposit_cents ? policyRow("Security deposit", `$${(v.security_deposit_cents/100).toFixed(0)}`) : null}
              </tbody>
            </table>
          </div>
          <div>
            <h2 style={{...style.h2, marginTop:0, fontSize:24}}>Policies</h2>
            <table style={{borderCollapse:"collapse"}}>
              <tbody>
                {policyRow("Setup buffer", `${v.setup_buffer_minutes || 0} min`)}
                {policyRow("Teardown buffer", `${v.teardown_buffer_minutes || 0} min`)}
                {policyRow("Catering", v.catering_allowed)}
                {policyRow("Outside food", v.outside_food_allowed)}
                {policyRow("Alcohol", v.alcohol_allowed)}
                {policyRow("Amplified sound", v.amplified_sound_allowed)}
                {policyRow("Filming", v.filming_allowed)}
                {policyRow("Insurance required", v.insurance_required)}
                {policyRow("Security required", v.security_required)}
              </tbody>
            </table>
          </div>
        </div>

        {permitted.length > 0 && (
          <>
            <h2 style={style.h2}>Permitted uses</h2>
            <div style={style.amenityRow}>{permitted.map(p => <span key={p} style={style.chip}>{p.replace(/_/g," ")}</span>)}</div>
          </>
        )}
        {prohibited.length > 0 && (
          <>
            <h2 style={style.h2}>Prohibited uses</h2>
            <div style={style.amenityRow}>{prohibited.map(p => <span key={p} style={{...style.chip, background:"rgba(160,43,28,0.12)", color:"#a04b00"}}>{p.replace(/_/g," ")}</span>)}</div>
          </>
        )}

        {/* INQUIRY PANEL */}
        <div style={{background:"#fff", padding:24, marginTop:32, border:"1px solid #ddd", borderRadius:8, maxWidth:640}}>
          <div style={style.eyebrow}>Booking</div>
          <div style={{fontSize:13, color:"#666", margin:"4px 0 14px"}}>
            {r.booking_mode?.replace(/_/g, " ")} · {r.management_mode?.replace(/_/g, " ")}
          </div>
          <button
            data-testid="v2-venue-inquire-cta"
            disabled
            title="Inquiry form will land in Stage 3B"
            style={{
              background:"var(--gold, #B8913A)", color:"#fff", border:"none",
              padding:"12px 22px", fontSize:12, letterSpacing:"0.14em",
              textTransform:"uppercase", cursor:"not-allowed", opacity:0.7,
            }}
          >{r.cta_text}</button>
          {r.cta_disclosure && (
            <p style={{fontSize:12, color:"#666", marginTop:12, fontStyle:"italic"}} data-testid="v2-venue-disclosure">
              {r.cta_disclosure}
            </p>
          )}
          <p style={{fontSize:11, color:"#666", marginTop:12}}>
            Preview only. The full request-to-book flow launches in Stage 3B once you approve.
          </p>
        </div>
      </main>
    </div>
  );
}
